<div class="d-flex align-items-center flex-wrap px-2 px-lg-4 gap-3 my-2">
  @for (option of jobReportTypes; track option) {
    <div>
      <div class="form-check">
        <input
          id="{{ option }}"
          class="form-check-input"
          type="radio"
          [value]="option"
          (change)="jobReportSelectRadio($event)"
          [checked]="option === selectedJobReportType"
        />
        <label class="form-check-label" for="{{ option }}">
          {{ option }}
        </label>
      </div>
    </div>
  }
  <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
  <button
    (click)="mailBillingReport()"
    [disabled]="!(jobReportDataList?.length && allowBillingReportExport)"
    class="btn btn-sm btn-success"
  >
    Export Results (*.xlsx)
  </button>
</div>

<div>
  @if (largeView) {
    <gtapp-gt-custom-table
      [deskTopTableData]="jobReportDataList"
      [desktopTableDetails]="jobReportDetailsTableView"
      [otherParams]="otherParams"
      (paginationChange)="onChangePagination($event)"
      (rowClick)="onJobTableRowClick($event)"
      (sortColumn)="sortColumn($event)"
      (searchColumn)="searchColumn($event)"
    ></gtapp-gt-custom-table>
  } @else {
    <gtapp-card-list
      [mobileCardBackendData]="jobReportDataList"
      [mobileCardDetails]="jobReportDetailsMobileView"
      (rowClick)="onJobTableRowClick($event)"
      (sortColumn)="sortColumn($event)"
      (searchColumn)="searchColumn($event)"
      [otherParams]="otherParams"
      (paginationChange)="onChangePagination($event)"
    ></gtapp-card-list>
  }
</div>

<ng-template #siteClientLookup let-siteClientLookupTempRef="dialogRef">
  <div class="flex-grow-1 flex-xl-grow-0">
    @if (selectedClient?.id) {
      <div>
        <dl class="px-2 px-md-4">
          <dt>Client</dt>
          <dd (click)="editField('client')" class="link-edit">
            {{ selectedClient?.company_name }}
          </dd>
        </dl>
      </div>
    } @else {
      <div>
        <gtapp-auto-complete
          [data]="clientDropDownList"
          placeHolder="Client"
          searchKeyword="company_name"
          [itemTemplate]="clientTemplate"
          (inputChanged)="onClientSearch($event)"
          [initialValue]="selectedClient?.company_name"
          (selected)="onClientSelect($event)"
          [enableCloseOption]="true"
          inputId="clientLookupId"
          (fieldCleared)="editField('client')"
          (inputFocused)="inputFocused('client')"
        >
        </gtapp-auto-complete>

        <ng-template #clientTemplate let-item>
          <div>
            {{ item?.company_name }}
          </div>
        </ng-template>
      </div>
    }
  </div>
  @if (selectedClient?.id) {
    <div class="flex-grow-1 flex-xl-grow-0">
      @if (selectedSite?.id) {
        <div>
          <dl class="px-2 px-md-4">
            <dt>Site</dt>
            <dd (click)="editField('site')" class="link-edit">
              {{ selectedSite?.company_name }}
            </dd>
          </dl>
        </div>
      } @else {
        <div>
          <gtapp-auto-complete
            [data]="siteListData"
            placeHolder="Site"
            searchKeyword="company_name"
            [initialValue]="selectedSite?.company_name"
            [itemTemplate]="siteTemplate"
            (inputChanged)="onSiteSearch($event)"
            (selected)="onSelectSite($event)"
            inputId="siteId"
            [enableCloseOption]="true"
            (fieldCleared)="editField('site')"
            (inputFocused)="inputFocused('site')"
          >
          </gtapp-auto-complete>

          <ng-template #siteTemplate let-item>
            <div>
              <div class="fw-medium">
                {{ item?.company_name }}
              </div>
              <div class="small-font text-secondary">
                {{ item?.address?.full_address }}
              </div>
            </div>
          </ng-template>
        </div>
      }
    </div>
  }
  @if (selectedSubContactor?.id) {
    <div>
      <dl class="px-2 px-md-4">
        <dt>Subcontractor</dt>
        <dd (click)="editField('subContractor')" class="link-edit">
          {{ selectedSubContactor?.company_name }}
        </dd>
      </dl>
    </div>
  } @else {
    <div>
      <gtapp-auto-complete
        [data]="subContractorDataList"
        placeHolder="Subcontractor"
        searchKeyword="company_name"
        [itemTemplate]="subContractorLookupTemplate"
        (inputChanged)="onSubContractorSearch($event)"
        [initialValue]="selectedSubContactor?.company_name"
        (selected)="onSubContractorSelect($event)"
        [enableCloseOption]="true"
        inputId="subContractorLookupId"
        (fieldCleared)="editField('subContractor')"
        (inputFocused)="inputFocused('subContractor')"
      >
      </gtapp-auto-complete>

      <ng-template #subContractorLookupTemplate let-item>
        <div>
          {{ item?.company_name }}
        </div>
      </ng-template>
    </div>
  }
  <div>
    <!-- @if (selectedJobType?.id) {
      <dl>
        <dt>Job Type</dt>
        <dd (click)="editField('jobType')" class="link-edit">
          {{ selectedJobType?.name }}
        </dd>
      </dl>
    } @else { -->
    <div class="form-floating">
      <select
        class="form-select form-select-lg"
        placeHolder="Job Type"
        role="button"
        id="jobTypeSelectFieldId"
        [ngModel]="selectedJobType?.id || ''"
        (change)="onSelectJobType($event)"
      >
        <option [value]="''">All</option>
        @for (jType of jobTypesDataList; track $index) {
          <option [value]="jType.id">
            {{ jType?.name }}
          </option>
        }
      </select>
      <label>Job Type</label>
    </div>
    <!-- } -->
  </div>
</ng-template>
